import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule, RouterOutlet } from '@angular/router';
import { BreakpointQuery } from '../model/breakpoint-query';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
})
export class AppComponent implements OnInit {
  title = 'Sondis';

  isMobileView: boolean | undefined;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.breakpointObserver
      .observe(BreakpointQuery.Compact)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state) => (this.isMobileView = state.matches));
  }
}
